import React from "react";
import { connect } from "react-redux";
import { Modal } from "react-bootstrap";

import { getLoggedProfile } from "../../model/profile";
import { orderInsurance } from "../../model/insurance";

import { commonErr } from "../../components/common/errors";
import { TypeRegBox, isPhoneValid, isEmptyObj } from "../../components/common/common";
import { LoadingPage } from "../common/loading";

class RegisterBox extends React.Component {
	state = {
		err: commonErr.INNIT,
		errMsg: "",
		name: "",
		phoneNumber: "",
		comment: "",
		modelName: "",
		step: 1,
	};

	componentDidMount() {
		this.refreshCheckFilled();

		getLoggedProfile().then((resp) => {
			if (resp.data.data && resp.data.data.profile) {
				const profile = resp.data.data.profile;
				this.setState({
					name: profile.name,
					phoneNumber: profile.phoneNumber,
				});
			}
		});
	}

	onHandleInputChange = (e) => {
		this.setState({
			[e.target.name]: e.target.value,
		});
	};

	isValidInfo() {
		const { type } = this.props;
		this.refreshCheckFilled();

		if (this.state.name === "" || !this.state.name) {
			this.setState({
				isNameFilled: false,
			});
			return "Bạn chưa điền tên";
		}
		if (this.state.phoneNumber === "" || !this.state.phoneNumber) {
			this.setState({
				isPhoneFilled: false,
			});
			return "Bạn chưa điền số điện thoại";
		}
		// if(!isPhoneValid(this.state.phoneNumber)){
		// 		this.setState({
		// 				isPhoneFilled: false,
		// 		})
		// 		return "Số điện thoại không hợp lệ"
		// }

		if (type === TypeRegBox.MODEL_NOT_FOUND) {
			if (this.state.modelName === "" || !this.state.modelName) {
				this.setState({
					isModelNameFill: false,
				});
				return "Bạn chưa điền thông tin xe";
			}
		}

		return "";
	}

	refreshCheckFilled() {
		this.setState({
			isNameFilled: true,
			isPhoneFilled: true,
			isModelNameFill: true,
		});
	}

	onSubmit = () => {
		const { type, pkgPrice, infoCar, pkgTNDS } = this.props;
		const { name, phoneNumber, modelName, comment } = this.state;
		const message = this.isValidInfo();
		const { price } = this.props.ins;

		if (message !== "") {
			this.setState({
				step: 0,
				err: commonErr.FAIL,
				errMsg: message,
			});
			return;
		}

		let data;
		this.setState({
			err: commonErr.LOADING,
		});

		if (type === TypeRegBox.MODEL_NOT_FOUND) {
			data = {
				type: type,
				name: name,
				phoneNumber: phoneNumber,
				modelName: modelName,
				comment: comment,
			};
		} else if (type === TypeRegBox.BOOKING) {
			if (infoCar !== null && pkgPrice !== undefined) {
				if (isEmptyObj(pkgTNDS)) {
					data = {
						type: type,
						name: name,
						phoneNumber: phoneNumber,
						modelId: infoCar.modelId,
						transmission: infoCar.transmission,
						regType: infoCar.regType,
						regDay: infoCar.regDay,
						year: infoCar.year,
						terms: infoCar.terms,
						price: JSON.stringify(pkgPrice),
					};
				} else {
					data = {
						type: type,
						name: name,
						phoneNumber: phoneNumber,
						modelId: infoCar.modelId,
						transmission: infoCar.transmission,
						regType: infoCar.regType,
						regDay: infoCar.regDay,
						year: infoCar.year,
						terms: infoCar.terms,
						price: JSON.stringify(pkgPrice),
						vehicleType: pkgTNDS.vehicleType,
						buySeat: pkgTNDS.buySeat,
						priceTNDS: JSON.stringify(pkgTNDS.priceTNDS),
					};
				}
			} else if (infoCar !== null && pkgPrice === undefined && pkgTNDS === undefined) {
				data = {
					type: type,
					name: name,
					phoneNumber: phoneNumber,
					regType: infoCar.regType,
					vehicleType: infoCar.vehicleType,
					buySeat: infoCar.buySeat,
					priceTNDS: JSON.stringify(price),
				};
			}
		} else {
			data = {
				type: TypeRegBox.INS_NOT_FOUND,
				name: name,
				phoneNumber: phoneNumber,
			};
		}

		orderInsurance(data).then((response) => {
			if (response.data.error >= commonErr.SUCCESS) {
				this.setState({
					step: 0,
					err: response.data.error,
					errMsg: "",
				});
			} else {
				this.setState({
					step: 0,
					err: response.data.error,
					errMsg: response.data.errorMessage,
				});
			}
		});
	};

	close = () => {
		const { err } = this.state;
		if (err >= commonErr.SUCCESS) {
			this.setState({
				step: 1,
				err: commonErr.INNIT,
				errMsg: "",
			});
			this.props.hide();
		} else {
			this.setState({
				step: 1,
				err: commonErr.INNIT,
				errMsg: "",
			});
		}
	};

	render() {
		const { type } = this.props;
		const { err, errMsg, name, phoneNumber, modelName, comment, step } = this.state;

		let content;
		if (err === commonErr.LOADING) {
			content = <LoadingPage />;
		} else if (step === 1) {
			if (type === TypeRegBox.MODEL_NOT_FOUND) {
				content = (
					<Modal.Body>
						<div className="modal-input-body">
							<h5 className="textAlign-center">Bạn không tìm thấy thông tin xe</h5>
							<div className="popup-ins-container">
								<p>
									Để lại thông tin cho Mioto ngay hoặc gọi đến hotline
									<strong>
										<a className="text-primary" href="tel:19009217">
											{" "}
											19009217{" "}
										</a>
									</strong>
									(9AM-9PM). Nhân viên Mioto sẽ liên hệ lại bạn ngay trong thời gian sớm nhất. Xin cám ơn.
								</p>
							</div>
							<div className="form-default">
								<div className="line-form">
									<div className="wrap-input">
										<input
											className="value"
											name="name"
											value={name}
											onChange={(e) => this.onHandleInputChange(e)}
											placeholder="Tên chủ xe"
										/>
									</div>
								</div>
							</div>
							<div className="form-default">
								<div className="line-form">
									<div className="wrap-input">
										<input
											className="value"
											name="phoneNumber"
											value={phoneNumber}
											onChange={(e) => this.onHandleInputChange(e)}
											placeholder="Số điện thoại"
										/>
									</div>
								</div>
							</div>
							<div className="form-default">
								<div className="line-form">
									<div className="wrap-input">
										<input
											className="value"
											name="modelName"
											value={modelName}
											onChange={(e) => this.onHandleInputChange(e)}
											placeholder="Thông tin xe"
										/>
									</div>
								</div>
							</div>
							<div className="form-default">
								<div className="line-form end custom-textarea">
									<textarea
										className="textarea"
										name="comment"
										value={comment}
										onChange={(e) => this.onHandleInputChange(e)}
										placeholder="Lời nhắn đến Mioto"
									/>
								</div>
							</div>
							<a className="btn btn-primary btn--m" onClick={() => this.onSubmit()}>
								GỬI THÔNG TIN
							</a>
						</div>
					</Modal.Body>
				);
			} else if (type === TypeRegBox.INS_NOT_FOUND) {
				content = (
					<Modal.Body>
						<div className="modal-input-body">
							<h5 className="textAlign-center">Tôi cần tư vấn thêm</h5>
							<div className="popup-ins-container">
								<p>
									Cám ơn bạn đã quan tâm sản phẩm <strong>Bảo hiểm xe ô tô </strong>qua ứng dụng Mioto !{" "}
								</p>
								<p>
									Bạn vui lòng cho Mioto xin thông tin số điện thoại, nhân viên Mioto sẽ liên hệ bạn ngay trong thời
									gian sớm nhất (từ 30-60 phút kể từ khi nhận được thông tin).
								</p>
								<p>
									Nếu cần hỗ trợ bạn vui lòng gọi đến Mioto hotline{" "}
									<strong>
										{" "}
										<a className="text-primary" href="tel:19009217">
											19009217{" "}
										</a>
									</strong>
									(9AM-9PM) hoặc inbox{" "}
									<a className="link-fanpage" target="_blank" href="https://www.messenger.com/t/mioto.vn">
										Mioto Fanpage
									</a>
									. Xin cám ơn.
								</p>
							</div>
							<div className="form-default">
								<div className="line-form">
									<div className="wrap-input">
										<input
											className="value"
											name="name"
											value={name}
											onChange={(e) => this.onHandleInputChange(e)}
											placeholder="Tên chủ xe"
										/>
									</div>
								</div>
							</div>
							<div className="form-default">
								<div className="line-form">
									<div className="wrap-input">
										<input
											className="value"
											name="phoneNumber"
											value={phoneNumber}
											onChange={(e) => this.onHandleInputChange(e)}
											placeholder="Số điện thoại"
										/>
									</div>
								</div>
							</div>
							<a className="btn btn-primary btn--m" onClick={() => this.onSubmit()}>
								Gửi thông tin
							</a>
						</div>
					</Modal.Body>
				);
			} else if (type === TypeRegBox.BOOKING || type === TypeRegBox.BOOKING_TNDS) {
				content = (
					<Modal.Body>
						<div className="modal-input-body">
							<h5 className="textAlign-center">Đặt mua sản phẩm</h5>
							<div className="popup-ins-container">
								<p>
									Cám ơn bạn đã đặt mua sản phẩm <strong>Bảo hiểm xe ô tô </strong>qua ứng dụng Mioto !{" "}
								</p>
								<p>
									Bạn vui lòng cho Mioto xin thông tin số điện thoại, nhân viên Mioto sẽ liên hệ bạn ngay trong thời
									gian sớm nhất (từ 30-60 phút kể từ khi nhận được thông tin).
								</p>
								<p>
									Nếu cần hỗ trợ bạn vui lòng gọi đến Mioto hotline{" "}
									<strong>
										{" "}
										<a className="text-primary" href="tel:19009217">
											19009217{" "}
										</a>
									</strong>
									(9AM-9PM) hoặc inbox{" "}
									<a className="link-fanpage" target="_blank" href="https://www.messenger.com/t/mioto.vn">
										Mioto Fanpage
									</a>
									. Xin cám ơn.
								</p>
							</div>
							<div className="form-default">
								<div className="line-form">
									<div className="wrap-input">
										<input
											className="value"
											name="name"
											value={name}
											placeholder="Tên chủ xe"
											onChange={(e) => this.onHandleInputChange(e)}
										/>
									</div>
								</div>
							</div>
							<div className="form-default">
								<div className="line-form">
									<div className="wrap-input">
										<input
											className="value"
											name="phoneNumber"
											value={phoneNumber}
											placeholder="Số điện thoại"
											onChange={(e) => this.onHandleInputChange(e)}
										/>
									</div>
								</div>
							</div>
							<a className="btn btn-primary btn--m" onClick={() => this.onSubmit()}>
								Gửi thông tin
							</a>
						</div>
					</Modal.Body>
				);
			}
		} else {
			content = (
				<Modal.Body>
					<div className="modal-input-body">
						{err >= commonErr.SUCCESS ? (
							<>
								<h5 className="textAlign-center">Thông tin đã được gửi</h5>
								<div className="popup-ins-container">
									<div className="notice-form notice-form-m">
										<label className="label">Tên chủ xe: {name}</label>
										<label className="label">Số điện thoại: {phoneNumber}</label>
									</div>
									<p>Mioto sẽ liên hệ bạn ngay trong thời gian sớm nhất. Xin cám ơn!</p>
								</div>
							</>
						) : (
							<>
								<h5 className="textAlign-center">Thông tin chưa được gửi!</h5>
								<div className="popup-ins-container">
									<p>{errMsg}. Vui lòng gửi lại thông tin hoặc liên hệ với chúng tôi.</p>
								</div>
							</>
						)}
					</div>
				</Modal.Body>
			);
		}

		return (
			<Modal show={this.props.isShow} onHide={this.close} dialogClassName="modal-m modal-input">
				<Modal.Header closeButton={true} closeLabel={""}></Modal.Header>
				{content}
			</Modal>
		);
	}
}

function mapState(state) {
	return {
		ins: state.ins,
	};
}

RegisterBox = connect(mapState)(RegisterBox);
export default RegisterBox;
